import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';

import { AppLoading } from '@/components/AppLoading';

import type { ReactElement } from 'react';

/**
 * App front door at `/` (Phase 9 Pass 1 — AF-425).
 *
 * Replaces the bootstrap placeholder that shipped no-op "Primary/
 * Secondary action" buttons. Resolves the Auth0 session and routes
 * authenticated users into the dashboard (`/home`) and anonymous
 * users to sign-in (`/signin`). While the session is still hydrating
 * it renders a polite status node rather than redirecting prematurely
 * (which would bounce a signed-in user through `/signin`) or flashing
 * blank.
 */
export function RootRedirect(): ReactElement {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <AppLoading />;
  }

  return <Navigate to={isAuthenticated ? '/home' : '/signin'} replace />;
}
